module.exports = __webpack_public_path__ + "img/3화_8(1).d60b3dbd.jpg";